var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c_button",on:{"click":_vm.tapButton}},[(this.icon)?_c('span',{class:[this.icon]}):_vm._e(),_vm._v(" "+_vm._s(this.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }